<template>
    <div v-if="task && task._id">
        <div class="dbt-row dbt-list-item" id="dbt-singletask">
            <!-- LEFT SECTION -->
            <div class="dbt-col1" :style="{ border: (containerWidth > sideScrollWidth ? '0px' : '') }"
                :class="[{ 'dbt-col-mobile': containerWidth < 768 }]">
                <div class="dbt-section dbt-task-content dbt-ignore-drag"
                    :class="{ 'dbt-subtask-indent': task.isParentTask === false && !isSubtask }">
                    <div class="dbt-expand-wrapper">
                        <template v-if="hasSubtasks && !isSubtask">
                            <img id="dbt-toggle" class="dbt-cursor-pointer dbt-expand-icon" :src="arrowIcon"
                                alt="arrowIcon"
                                :style="`transform: rotateZ(${data.isExpanded ? '0' : '-90'}deg); width: 16px; height: 16px;`"
                                @click="$emit('toggle', true)">
                        </template>

                        <template v-else>
                            <img :src="dotIcon" alt="dotIcon">
                        </template>
                    </div>

                    <!-- Subtask pointer - HIDE when using tree lines (isSubtask=true) -->
                    <img v-if="!data?.isParentTask && !isSubtask" :src="lastChild ? pointer : extendedPointer" alt=""
                        class="dbt-align-baseline dbt-subtask-pointer dbt-expand-icon">

                    <!-- INVENTORY -->
                    <img v-if="task.deletedStatusKey === 2" :src="inventoryIcon" alt="inventory" class="dbt-ml-5" />
                    <img v-if="task.deletedStatusKey === 1" :src="deleteIcon" alt="delete" class="dbt-ml-5">

                    <!-- TASK STATUS -->
                    <TaskStatus :id="task._id + 'status'" :modelValue="taskStatus" :options="projectStatus"
                        :disabled="true" />

                    <!-- TASK TYPE -->
                    <ProjectTaskType :id="task._id + 'type'" :modelValue="taskType" :options="projectTaskType"
                        :disabled="true" :imgClasses="`dbt-ml-10`" />

                    <div @click="!showArchiveVar ? toggleTaskDetail(task) : ''"
                        class="dbt-name-wrapper dbt-name dbt-ml-6">
                        <!-- TASK NAME -->
                        <span class="dbt-text-ellipsis dbt-inline-block dbt-taskname" :title="taskName">
                            {{ taskName }}
                        </span>
                        <div class="dbt-flex dbt-align-center dbt-subtask-badge dbt-ml-5"
                            v-if="data?.isParentTask && ((showArchiveVar || searchedTask) ? data?.subtaskArray?.length : data?.subTasks)">
                            <img :src="subTaskImage" alt="subTaskImage" class="dbt-mr-2">
                            {{ (showArchiveVar || searchedTask) ? data?.subtaskArray?.length : data?.subTasks < 0 ? 0 :
                                data?.subTasks }} <div class="dbt-count-badge dbt-ml-5" v-if="myParentCounts">
                                {{ myParentCounts > 99 ? "+99" : myParentCounts }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- RIGHT SECTION -->
        <div class="dbt-col2 dbt-ignore-drag" v-if="containerWidth > 768">
            <div class="dbt-section dbt-task-content">
                <!-- CHAT COUNTS -->
                <span v-if="cardData?.find((x) => x === 2)" class="dbt-chat-col dbt-position-re dbt-field-col"
                    @click.stop="toggleTaskDetail(task, false, true)">
                    <img :src="chatIcon" alt="chatIcon" :class="{ 'dbt-cursor-pointer': !showArchiveVar }">
                    <div class="dbt-position-ab dbt-count-badge dbt-show-count" v-if="myCounts">
                        {{ myCounts > 99 ? "+99" : myCounts }}
                    </div>
                </span>

                <!-- ASSIGNEE -->
                <span class="dbt-assignee-col dbt-field-col"
                    v-if="checkPermission('task.task_assignee', true) !== null && cardData?.find((x) => x === 3)">
                    <Assignee
                        v-if="checkPermission('task.task_assignee', true) === true && checkPermission('task.task_list', true) == true"
                        :users="task.AssigneeUserId" :options="permittedOptions" :num-of-users="2" imageWidth="30px"
                        :addUser="false"
                        @selected="changeAssignee(checkApps('MultipleAssignees') ? 'add' : 'replace', $event)"
                        @removed="changeAssignee('remove', $event)" :isDisplayTeam="true"
                        :multiSelect="checkApps('MultipleAssignees')" />
                    <Assignee v-else :users="task.AssigneeUserId" :options="nonPermittedOptions" :num-of-users="2"
                        imageWidth="30px" :addUser="false"
                        @selected="changeAssignee(checkApps('MultipleAssignees') ? 'add' : 'replace', $event)"
                        @removed="changeAssignee('remove', $event)" :isDisplayTeam="true"
                        :multiSelect="checkApps('MultipleAssignees')" />
                </span>

                <!-- DUE DATE -->
                <span class="dbt-duedate-col dbt-field-col"
                    v-if="checkPermission('task.task_due_date', true) !== null && cardData?.find((x) => x === 4)">
                    <span v-if="task.DueDate">{{ convertDateFormat(task.DueDate, '', { showDayName: false }) }}</span>
                    <span v-else>-</span>
                </span>

                <!-- TASK PRIORITY -->
                <span class="dbt-priority-col dbt-field-col"
                    v-if="checkPermission('task.task_priority', true) !== null && cardData?.find((x) => x === 5)">
                    <div class="priority-badge" :class="priorityClass">
                        <div class="priority-icon-wrapper">
                            <Priority :priorityVal="task.Task_Priority" @select="updatePriority"
                                :permission="!showArchiveVar && checkPermission('task.task_priority', true) === true" />
                        </div>
                        <span class="priority-text">{{ priorityLabel }}</span>
                    </div>
                </span>

                <!-- KPI -->
                <span class="dbt-kpi-col dbt-field-col" v-if="cardData?.find((x) => x === 9)">
                    <span class="dbt-kpi-label">{{ task.isKpi ? 'KPI' : '-' }}</span>
                </span>

                <!-- TASK KEY -->
                <span class="dbt-key-col dbt-field-col" v-if="cardData?.find((x) => x === 6)">
                    {{ task.TaskKey }}
                </span>

                <!-- Created Date -->
                <span class="dbt-key-col dbt-field-col" v-if="cardData?.find((x) => x === 7)">
                    {{ convertDateFormat(task.createdAt, '', { showDayName: false }) }}
                </span>

                <!-- Created By -->
                <span class="dbt-createdby-col dbt-field-col" v-if="cardData?.find((x) => x === 8)">
                    <Assignee :users="[task?.Task_Leader]" :num-of-users="1" imageWidth="30px" :addUser="false" />
                </span>
                <template v-if="projectData?.viewColumn && projectData?.viewColumn.length && isCustomFields()">
                    <CustomFieldListViewColumnComponent :projectData="projectData" :task="task" />
                </template>
            </div>
        </div>
    </div>
    <ConfirmationSidebar v-model="showSidebar" :title="`${archive ? $t('Projects.archive') : $t('Projects.delete')}`"
        :message="archive ? $t('conformationmsg.archive') : $t('conformationmsg.delete')"
        :confirmationString="`${archive ? 'archive' : 'delete'}`"
        :acceptButtonClass="archive ? 'btn-primary' : 'btn-danger'"
        :acceptButton="`${archive ? $t('Projects.archive') : $t('Projects.delete')}`"
        @confirm="updateTask(), showSidebar = false" />
    </div>
</template>

<script setup>
// PACKAGES
import { ref, watch, defineProps, inject, defineEmits, defineComponent, computed, onMounted, provide } from "vue"

// COMPONENTS
import Assignee from "@/components/molecules/Assignee/Assignee.vue"
import Priority from "@/components/molecules/PriorityCompo/PriorityComp.vue"
import TaskStatus from "@/components/atom/TaskStatus/TaskStatus.vue"
import ProjectTaskType from "@/components/atom/TaskTypeSelection/TaskTypeSelection.vue"
import ConfirmationSidebar from "@/components/molecules/ConfirmationSidebar/ConfirmationSidebar.vue"
// UTILS
import taskClass from "@/utils/TaskOperations";
import { useConvertDate, useCustomComposable, useGetterFunctions } from "@/composable";
import { useStore } from "vuex";
import { useToast } from "vue-toast-notification"
import { useUpdateTasks } from "@/views/Projects/helper"
import { customField } from '../../../../customFieldView/helper.js';
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const { isCustomFields } = customField();
const containerWidth = inject('$containerWidth');
const userId = inject('$userId');
const { getUser } = useGetterFunctions();
const { getters, commit } = useStore();
const companyId = inject("$companyId");
const searchedTask = inject('searchedTask');
const { convertDateFormat } = useConvertDate();
const { checkPermission, checkApps } = useCustomComposable();
const showArchiveVar = inject("showArchived");
const $toast = useToast()
const { updateTaskByGroup } = useUpdateTasks();

// IMAGES
const arrowIcon = require("@/assets/images/svg/arrow_black.svg");
const inventoryIcon = require("@/assets/images/inventory_2.png");
const deleteIcon = require("@/assets/images/DeleteIcon.png");
const subTaskImage = require("@/assets/images/subtask2.png");
const pointer = require("@/assets/images/svg/pointer.svg");
const extendedPointer = require("@/assets/images/svg/pointer_extended.svg");
const chatIcon = require("@/assets/images/svg/ChatIcon.svg");
const dotIcon = require("@/assets/images/svg/dot_icon.svg");

// EMITS
const emit = defineEmits(["toggle", "createTask"]);

// COMPONENT
defineComponent({
    name: "DashboardTask-Component",

    components: {
        Assignee,
        Priority,
        TaskStatus,
        ConfirmationSidebar,
        ProjectTaskType
    }
})

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    },
    lastChild: {
        type: Boolean,
        default: false
    },
    parentAssignee: {
        type: Array,
        default: () => []
    },
    item: {
        type: Object,
        default: () => ({})
    },
    projectObject: {
        type: Object,
        default: () => ({})
    },
    sprintObject: {
        type: Object,
        default: () => ({})
    },
    cardData: {
        type: Array,
        default: () => []
    },
    isSubtask: {
        type: Boolean,
        default: false
    }
})

const showSidebar = ref(false);
const archive = ref(false);
const customFieldList = computed(() => (getters['settings/finalCustomFields'] && getters['settings/finalCustomFields'].length) ? JSON.parse(JSON.stringify(getters['settings/finalCustomFields'])) : []);

const companyUsers = computed(() => getters["settings/companyUsers"]?.map((x) => x.userId))

const projectData = ref(props.projectObject)
provide("selectedProject", {});

const companyOwner = computed(() => {
    return getters["settings/companyOwnerDetail"];
})
const sideScrollWidth = ref(769);

// Initialize task safely
const task = ref(props.data && Object.keys(props.data).length > 0 ? props.data : {});

// Computed for taskName with fallback
const taskName = computed(() => {
    return task.value?.TaskName || task.value?.taskName || '';
});

const toggleTaskDetail = inject('toggleTaskDetail')
const statusSearch = ref("");
const assigneeInProgress = ref({});

const projectStatus = computed(() => {
    return projectData.value?.taskStatusData?.filter((x) => x.name?.toLowerCase().includes(statusSearch.value.toLowerCase())) || []
})
const projectTaskType = computed(() => {
    return projectData.value?.taskTypeCounts || [];
})

const taskStatus = computed(() => {
    return projectData.value?.taskStatusData?.find((x) => x.key === task.value?.statusKey)
})
const taskType = computed(() => {
    return projectData.value?.taskTypeCounts?.find((x) => x.key === task.value?.TaskTypeKey)
})

const sprintData = computed(() => {
    return props.sprintObject || null;
})
const permittedOptions = computed(() => {
    let users = [];
    if (sprintData.value) {
        if (props.data?.isParentTask) {
            if (sprintData.value?.private) {
                users = sprintData.value?.AssigneeUserId || [];
            } else {
                if (projectData.value?.isPrivateSpace) {
                    users = projectData.value?.AssigneeUserId || [];
                } else {
                    users = companyUsers.value || [];
                }
            }
        } else {
            if (sprintData.value?.private) {
                users = (props.parentAssignee || []).filter((x) => sprintData.value?.AssigneeUserId?.includes(x))
            } else {
                users = props.parentAssignee || []
            }
        }
    }

    if (projectData.value?.isPrivateSpace) {
        users = users.filter((x) => projectData.value?.AssigneeUserId?.includes(x));
        return Array.from(new Set([...users, ...(props.data?.AssigneeUserId || [])]));
    } else {
        return users;
    }
})
const nonPermittedOptions = computed(() => {
    let users = [];
    if (sprintData.value) {
        if (props.data?.isParentTask) {
            if (sprintData.value?.private) {
                users = (sprintData.value?.AssigneeUserId || []).filter((x) => x === userId.value);
            } else {
                if (projectData.value?.isPrivateSpace) {
                    users = (projectData.value?.AssigneeUserId || []).filter((x) => x === userId.value);
                } else {
                    users = [userId.value];
                }
            }
        } else {
            users = (props.parentAssignee || [])?.filter((x) => x === userId.value)
            if (sprintData.value?.private) {
                users = users.filter((x) => sprintData.value?.AssigneeUserId?.includes(x))
            }
        }
    }
    if (projectData.value?.isPrivateSpace) {
        users = users.filter((x) => projectData.value?.AssigneeUserId?.includes(x));
        return users;
    } else {
        return users;
    }
})

const hasSubtasks = computed(() => {
    if (searchedTask?.value) {
        return task.value?.subtaskArray?.length > 0;
    }
    return task.value?.subTasks > 0 && task.value?.isParentTask;
});

const priorityConfig = computed(() => {
    const configs = {
        'HIGH': { label: 'Urgent', class: 'red-500' },
        'MEDIUM': { label: 'Medium', class: 'orange-500' },
        'LOW': { label: 'Low', class: 'green-500' },
    };
    return configs[task.value.Task_Priority];
});

const priorityLabel = computed(() => priorityConfig.value.label);
const priorityClass = computed(() => priorityConfig.value.class);

function manageCustomField(data) {
    if (!(data && data.length)) {
        return;
    }
    if (!task.value || !task.value._id) {
        return;
    }
    if (projectData.value?.viewColumn && projectData.value?.viewColumn.length) {
        let count = 0;
        let countFunction = (element) => {
            if (!element) return;
            if (count >= projectData.value?.viewColumn.length) {
                return;
            } else {
                let checkCustom = customFieldList.value.find((x) => (x._id === element.key) && (x?.isDelete) && (x?.type === 'task') && (x?.global || x?.projectId?.includes(task?.value?.ProjectID)));
                if (checkCustom && Object.keys(checkCustom).length) {
                    if (task.value?.customField?.[element.key]) {
                        if (checkCustom.fieldType === 'phone') {
                            task.value.customField[element.key] = {
                                ...checkCustom,
                                taskId: task.value?._id,
                                fieldValue: task.value.customField[element.key]?.fieldValue,
                                fieldCode: task.value.customField[element.key]?.fieldCode,
                                fieldFlag: task.value.customField[element.key]?.fieldFlag,
                                fieldPattern: task.value.customField[element.key]?.fieldPattern
                            }
                        } else {
                            task.value.customField[element.key] = {
                                ...checkCustom,
                                taskId: task.value?._id,
                                fieldValue: task.value.customField[element.key]?.fieldValue
                            }
                        }
                        count++;
                        countFunction(projectData.value.viewColumn[count]);
                    } else {
                        delete checkCustom?.fieldPattern;
                        delete checkCustom?.fieldValue;
                        delete checkCustom?.fieldCode;
                        delete checkCustom?.fieldFlag;
                        checkCustom.taskId = task.value?._id;
                        let newObject = {
                            [element.key]: checkCustom
                        };
                        if (!task.value.customField) {
                            task.value.customField = {};
                        }
                        task.value.customField = {
                            ...task.value.customField,
                            ...newObject
                        }
                        count++;
                        countFunction(projectData.value.viewColumn[count]);
                    }
                } else {
                    count++;
                    countFunction(projectData.value.viewColumn[count]);
                }
            }
        }
        countFunction(projectData.value.viewColumn[count])
    }
}

// Watchers
watch(() => props.data, (newVal, oldVal) => {
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        task.value = newVal;
        manageCustomField(customFieldList.value);
    }
});

watch(() => projectData.value?.viewColumn?.length, (newVal, oldVal) => {
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        manageCustomField(customFieldList.value);
    }
});

watch(() => getters['settings/finalCustomFields'], (newVal) => {
    manageCustomField(newVal);
}, { deep: true });

// onMounted
const taskCollapsed = inject("taskCollapsed");
onMounted(() => {
    if (props.data && Object.keys(props.data).length > 0) {
        task.value = props.data;
    }

    if (taskCollapsed.value !== undefined && !taskCollapsed.value) {
        emit("toggle");
    }
    manageCustomField(customFieldList.value);
})

function getUserData() {
    const user = getUser(userId.value);
    const userData = {
        id: user?.id,
        Employee_Name: user?.Employee_Name,
        companyOwnerId: companyOwner.value?.userId,
    }

    return userData;
}

function updateTask(value = null) {
    const deletedStatusKey = value !== null ? value : archive.value ? 2 : 1;
    const userData = getUserData();
    const project = {
        _id: projectData.value?._id,
        CompanyId: projectData.value?.CompanyId,
        lastTaskId: projectData.value?.lastTaskId,
        ProjectName: projectData.value?.ProjectName,
        ProjectCode: projectData.value?.ProjectCode
    }
    taskClass.updateArchiveDelete({
        companyId: companyId.value,
        projectData: project,
        sprintId: task.value?.sprintId,
        task: task.value,
        folderId: task.value?.folderObjId ? task.value.folderObjId : '',
        userData,
        deletedStatusKey,
    })
        .then((res) => {
            let sprint = {};
            if (task.value?.folderObjId) {
                sprint = projectData.value?.sprintsfolders?.[task.value.folderObjId]?.sprintsObj?.[task.value.sprintId];
            }
            else {
                sprint = projectData.value?.sprintsObj?.[task.value?.sprintId];
            }
            if (sprint) {
                sprint.tasks = sprint.tasks - (task.value?.isParentTask ? ((task.value?.subTasks || 0) + 1) : 1)
                commit("projectData/mutateSprints", { op: 'modified', data: { ...sprint } });
            }
            if (res?.status) {
                $toast.success(t(`Toast.Task_${value !== null ? 'restored' : archive.value ? 'archived' : 'deleted'}_successfully`), { position: "top-right" })
            }
        })
        .catch((err) => {
            console.error(err);
        })
}

// CHANGE ASSIGNEE
function changeAssignee(type, value) {
    if (!value?.id) return;
    if (assigneeInProgress.value[value?.id] && assigneeInProgress.value[value?.id] === type) return;
    assigneeInProgress.value[value?.id] = type;

    const userData = getUserData();

    let operation = ""

    if (type === "add") {
        operation = "assigneeAdd"
    } else if (type === 'remove') {
        operation = "assigneRemove"
    } else if (type === 'replace') {
        operation = "replace"
    }

    let updateObject = {
        AssigneeUserId: value.id
    }

    const project = {
        _id: projectData.value?._id,
        CompanyId: projectData.value?.CompanyId,
        lastTaskId: projectData.value?.lastTaskId,
        ProjectName: projectData.value?.ProjectName,
        ProjectCode: projectData.value?.ProjectCode
    }

    taskClass.updateAssignee({
        firebaseObj: updateObject,
        projectData: project,
        taskData: props.data,
        employeeName: getUser(value.id)?.Employee_Name,
        type: operation,
        userData
    })
        .then(() => {
            if (operation === "assigneRemove") {
                let index = task.value?.AssigneeUserId?.findIndex((x) => x === value.id);
                if (index > -1) {
                    task.value.AssigneeUserId.splice(index, 1);
                    commit("projectData/mutateSearchTask", { op: "modified", data: [task.value] });
                }
            }
            delete assigneeInProgress.value[value?.id];
            $toast.success(t(`Toast.Assignee ${type === "add" || type === "replace" ? 'added' : 'removed'} successfully`), { position: "top-right" })
        })
        .catch((error) => {
            delete assigneeInProgress.value[value?.id];
            console.error("ERROR in changeAssignee: ", error);
        })
}

// CHANGE PRIORITY
function updatePriority(val = null) {
    if (!val) return;
    updateTaskByGroup(props.data, val, 2);
}

const myCounts = computed(() => {
    let total = 0;

    if (getters["users/myCounts"]?.data?.[`task_${projectData.value?._id}_${task.value?.sprintId}_${task.value?._id}_comments`]) {
        total += getters["users/myCounts"]?.data?.[`task_${projectData.value?._id}_${task.value?.sprintId}_${task.value?._id}_comments`] || 0
    }

    return total;
})
const myParentCounts = computed(() => {
    let total = 0;

    if (getters["users/myCounts"]?.data?.[`parentTask_${projectData.value?._id}_${task.value?.sprintId}_${task.value?._id}_comments`]) {
        total += getters["users/myCounts"]?.data?.[`parentTask_${projectData.value?._id}_${task.value?.sprintId}_${task.value?._id}_comments`] || 0
    }

    return total;
})
</script>

<style src="./style.css"></style>